module.exports = __webpack_public_path__ + "img/app-store-en.d0558d91.svg";